import { OrgSdk } from 'lib-klab-sdks';

type ExecutableVersionResponse = OrgSdk.ExecutableVersionResponse;

function deepClone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
}

const defaultResponse: ExecutableVersionResponse = {
    version: '1.0.0',
    description: 'KlabTime installer',
    url: 'https://klab.inclub.world/downloads/klab-1.0.0.exe',
    releaseDate: '2026-02-18',
};

export const executableVersionSdkMock = {
    getCurrentExecutableVersion: (): ExecutableVersionResponse => deepClone(defaultResponse),
};
